"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var EffectValue_1 = require("./EffectValue");
var DropdownEffectValue = (function (_super) {
    tslib_1.__extends(DropdownEffectValue, _super);
    function DropdownEffectValue(rawData, version) {
        return _super.call(this, EffectValue_1.EffectValueType.DropDown, rawData, version) || this;
    }
    return DropdownEffectValue;
}(EffectValue_1.EffectValue));
exports.DropdownEffectValue = DropdownEffectValue;
//# sourceMappingURL=DropdownEffectValue.js.map